import React, {useRef, useState, useEffect} from 'react';
import {ContentHeader} from '@components';
import {toast} from 'react-toastify';
import Card from 'react-bootstrap/Card';
import {Form} from 'react-bootstrap';
import Select from 'react-select';
import 'bootstrap/scss/bootstrap.scss'; // Or the one above.
import 'tempusdominus-bootstrap/src/sass/tempusdominus-bootstrap-build.scss';
import {DateTimePicker} from 'react-tempusdominus-bootstrap';
import {PfButton} from '@profabric/react-components';
import * as AuthService from '../services/auth';
import Table from './report/Table';
import Table2 from './report/Table2';
import Table3 from './report/Table3';
import Table4 from './report/Table4';
import TableMY from './report/TableMY';
import Table7 from './report/Table7';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';

export default function Report() {
  const linkedPicker1Ref = useRef();
  const linkedPicker2Ref = useRef();
  //const ref = React.useRef<HTMLInputElement>(null);

  const [reportData, setReportData] = useState<any[]>([]);
  // const [reportData, setReportData] = useState<any>({
  //   columns: [{title: '#', data: 'id'}],
  //   params: [{id: '-'}]
  // });
  const [reportDataQr, setReportDataQr] = useState<any[]>([]);
  const [reportDataReward, setReportDataReward] = useState<any[]>([]);
  const [reportDataSummary, setReportDataSummary] = useState<any[]>([]);
  const [reportDataSummaryMy, setReportDataSummaryMy] = useState<any[]>([]);
  const [reportDataLoyalty, setReportDataLoyalty] = useState<any[]>([]);
  // const [reportDataSummaryTw, setReportDataSummaryTw] = useState<any[]>([]);
  // const [reportDataSummaryHk, setReportDataSummaryHk] = useState<any[]>([]);
  // const [reportDataSummaryCn, setReportDataSummaryCn] = useState<any[]>([]);

  const [isLoading, setLoading] = useState(false);
  const [isShowTBUser, setShowTBUser] = useState('d-none');
  const [isShowTBQr, setShowTBQr] = useState('d-none');
  const [isShowTBReward, setShowTBReward] = useState('d-none');
  const [isShowTBSummary, setShowTBSummary] = useState('d-none');
  const [isShowTBSummaryMy, setShowTBSummaryMy] = useState('d-none');
  const [isShowTBLoyalty, setShowTBLoyalty] = useState('d-none');
  // const [isShowTBSummaryTw, setShowTBSummaryTw] = useState('d-none');
  // const [isShowTBSummaryHk, setShowTBSummaryHk] = useState('d-none');
  // const [isShowTBSummaryCn, setShowTBSummaryCn] = useState('d-none');
  const [country, setCountry] = useState('');
  const [reportName, setReportName] = useState('');
  const [dropdownReport, setDropdownReport] = useState<any[]>([]);
  const [dropdownCountry, setDropdownCountry] = useState<any[]>([]);

  // const [cols, setCols] = useState<any[]>([{'nodata' : '-'}]);

  useEffect(() => {
    downloadDropdownWs();
  }, []);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [state, setState] = useState({
    reportid: {value: '', label: ''},
    countryid: {value: '', label: ''},
    date_start: new Date(),
    date_end: new Date()
  });

  const downloadDropdownWs = async () => {
    try {
      const dropdowns = await AuthService.downloadDropdown();
      if(dropdowns.error) throw "timeout";
      
      const reportDropdown = dropdowns.reduce(function (acc: any, curr: any) {
        if (curr.TYPE === 'REPORT') {
          delete curr.TYPE;
          return [...acc, curr];
        }
        return [...acc];
      }, []);

      const countryDropdown = dropdowns.reduce(function (acc: any, curr: any) {
        if (curr.TYPE === 'COUNTRY') {
          delete curr.TYPE;
          return [...acc, curr];
        }
        return [...acc];
      }, []);

      setDropdownReport(reportDropdown);
      setDropdownCountry(countryDropdown);
      console.log(reportDropdown);
      console.log(countryDropdown);
    } catch (error: any) {
      dispatch(logoutUser());
      navigate('/login');
    }
  };

  const downloadReportWs = async () => {
    if (
      !(
        (
          (state.reportid.value === '1' && isShowTBQr === 'd-inline') ||
          (state.reportid.value === '2' && isShowTBUser === 'd-inline') ||
          (state.reportid.value === '3' && isShowTBReward === 'd-inline') ||
          (state.reportid.value === '6' && isShowTBSummaryMy === 'd-inline') ||
          (state.reportid.value === '7' && isShowTBLoyalty === 'd-inline')
        )
        // (state.reportid.value === '6' &&
        //   state.countryid.value === 'MY' &&
        //   isShowTBSummaryMy === 'd-inline') ||
        // (state.reportid.value === '6' &&
        //   state.countryid.value === 'TW' &&
        //   isShowTBSummaryTw === 'd-inline') ||
        // (state.reportid.value === '6' &&
        //   state.countryid.value === 'HK' &&
        //   isShowTBSummaryHk === 'd-inline') ||
        // (state.reportid.value === '6' &&
        //   state.countryid.value === 'CN' &&
        //   isShowTBSummaryCn === 'd-inline') ||
        // (state.reportid.value === '4' && isShowTBSummary === 'd-inline')
      )
    ) {
      setShowTBUser('d-none');
      setShowTBQr('d-none');
      setShowTBReward('d-none');
      setShowTBSummary('d-none');
      setShowTBSummaryMy('d-none');
      setShowTBLoyalty('d-none');
      // setShowTBSummaryTw('d-none');
      // setShowTBSummaryHk('d-none');
      // setShowTBSummaryCn('d-none');
    }
    setLoading(true);
    try {
      if (state.reportid.value === '' || state.countryid.value === '') {
        toast.error('Select country or report type.');
        setLoading(false);
      } else {
        let _date_start = new Date(state.date_start);
        let _date_end = new Date(state.date_end);

        const offset = _date_start.getTimezoneOffset();
        _date_start = new Date(
          _date_start.getTime() - offset * 60 * 1000
        );
        _date_end = new Date(
          _date_end.getTime() - offset * 60 * 1000
        );

        const params = await AuthService.downloadReport(
          state.reportid.value,
          _date_start.toISOString().split('T')[0],
          _date_end.toISOString().split('T')[0],
          state.countryid.value
        );

        //find cols
        var columns: any[] = [];
        // var columnNames = Object.keys(params[0]);
        // for (var i in columnNames) {
        //   columns.push({
        //     data: columnNames[i],
        //     title: columnNames[i]
        //   });
        // }

        if (state.reportid.value === '2') {
          const data = {columns, params};
          setReportData(params);
          setReportName(': User report');
          setShowTBUser('d-inline');
        }

        if (state.reportid.value === '1') {
          setReportDataQr(params);
          setReportName(': QR report');
          setShowTBQr('d-inline');
        }

        if (state.reportid.value === '3') {
          setReportDataReward(params);
          setReportName(': Reward report');
          setShowTBReward('d-inline');
        }

        if (state.reportid.value === '4') {
          setReportDataSummary(params);
          setReportName(': Summary report');
          setShowTBSummary('d-inline');
        }

        if (state.reportid.value === '6') {
          setReportDataSummaryMy(params);
          setCountry(state.countryid.value);
          setReportName(': Summary report (V2)');
          setShowTBSummaryMy('d-inline');
        }

        if (state.reportid.value === '7') {
          setReportDataLoyalty(params);
          setCountry(state.countryid.value);
          setReportName(': Loyalty report');
          setShowTBLoyalty('d-inline');
        }

        // if (state.reportid.value === '6' && state.countryid.value === 'MY') {
        //   setReportDataSummaryMy(params);
        //   setCountry('MY');
        //   setReportName(': Summary report (MY)');
        //   setShowTBSummaryMy('d-inline');
        // }

        // if (state.reportid.value === '6' && state.countryid.value === 'CN') {
        //   setReportDataSummaryMy(params);
        //   setCountry('CN');
        //   setReportName(': Summary report (CN)');
        //   setShowTBSummaryMy('d-inline');
        // }

        // if (state.reportid.value === '6' && state.countryid.value === 'TW') {
        //   setReportDataSummaryMy(params);
        //   setCountry('TW');
        //   setReportName(': Summary report (TW)');
        //   setShowTBSummaryMy('d-inline');
        // }

        // if (
        //   state.reportid.value === '6' &&
        //   (state.countryid.value === 'HK' || state.countryid.value === 'MO')
        // ) {
        //   setReportDataSummaryMy(params);
        //   setCountry('HK');
        //   setReportName(': Summary report (HK/MO)');
        //   setShowTBSummaryMy('d-inline');
        // }
        setLoading(false);
      }
    } catch (error: any) {}
  };

  return (
    <div>
      <ContentHeader title="Report" />
      <section className="content">
        <div className="container-fluid">
          <Card className="card-primary">
            <Card.Header>Report Filters</Card.Header>
            <Card.Body>
              {/* <Form> */}
              <div className="row col-md-12">
                <Form.Group className="mb-3 col-md-3">
                  <Form.Label>Select Country</Form.Label>
                  <Select
                    options={dropdownCountry}
                    id="countryid"
                    onChange={(v: any) =>
                      setState((prevState) => ({...prevState, countryid: v}))
                    }
                  />
                </Form.Group>
                <Form.Group className="mb-3 col-md-3">
                  <Form.Label>Select Report Type</Form.Label>
                  <Select
                    options={dropdownReport}
                    id="reportid"
                    onChange={(v: any) =>
                      setState((prevState) => ({...prevState, reportid: v}))
                    }
                  />
                </Form.Group>
                <Form.Group className="mb-3 col-md-6">
                  <Form.Label>Select Date Range</Form.Label>
                  <div className="row">
                    <div className="mb-3 col-md-6">
                      <DateTimePicker
                        pickerRef={linkedPicker1Ref}
                        format="YYYY-MM-DD"
                        extraFormats={['YYYY-MM-DD', 'YY-MM-DD']}
                        onChange={(e: any) => {
                          linkedPicker2Ref.current.datetimepicker(
                            'minDate',
                            e.date
                          );
                          setState((prevState) => ({
                            ...prevState,
                            date_start: e.date
                          }));
                        }}
                      />
                    </div>
                    <div className="mb-3 col-md-6">
                      <DateTimePicker
                        pickerRef={linkedPicker2Ref}
                        format="YYYY-MM-DD"
                        extraFormats={['YYYY-MM-DD', 'YY-MM-DD']}
                        onChange={(e: any) => {
                          linkedPicker1Ref.current.datetimepicker(
                            'maxDate',
                            e.date
                          );
                          setState((prevState) => ({
                            ...prevState,
                            date_end: e.date
                          }));
                        }}
                      />
                    </div>
                  </div>
                </Form.Group>
              </div>

              <Form.Group className="mb-3 col-md-6">
                <PfButton block onClick={downloadReportWs} loading={isLoading}>
                  Submit
                </PfButton>
              </Form.Group>
              {/* </Form> */}
            </Card.Body>
          </Card>
          <Card>
            <Card.Header>Report {reportName}</Card.Header>
            <Card.Body className={isShowTBUser}>
              {/* <Table names={reportData} /> */}
              <Table names={reportData} />
            </Card.Body>
            <Card.Body className={isShowTBQr}>
              <Table2 names={reportDataQr} />
            </Card.Body>
            <Card.Body className={isShowTBReward}>
              <Table3 names={reportDataReward} />
            </Card.Body>
            <Card.Body className={isShowTBSummary}>
              <Table4 names={reportDataSummary} />
            </Card.Body>
            <Card.Body className={isShowTBSummaryMy}>
              <TableMY names={reportDataSummaryMy} country={country} />
            </Card.Body>
            <Card.Body className={isShowTBLoyalty}>
              <Table7 names={reportDataLoyalty} country={country} />
            </Card.Body>
            {/* <Card.Body className={isShowTBSummaryTw}>
          <TableTW names={reportDataSummaryTw} />
        </Card.Body>
        <Card.Body className={isShowTBSummaryHk}>
          <TableHK names={reportDataSummaryHk} />
        </Card.Body>
        <Card.Body className={isShowTBSummaryCn}>
          <TableCN names={reportDataSummaryCn} />
        </Card.Body> */}
          </Card>
        </div>
      </section>
    </div>
  );
}
